module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//npc.png?v=02b5c875";